export const uploadTermsFileErrors = {
  INVALID_PROPERTY_TERMS_FILE_TYPE: 'INVALID_PROPERTY_TERMS_FILE_TYPE',
};

export const others = {};
